import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import ContractorPortal from './pages/ContractorPortal'

// Simple path-based routing - contractor portal is completely separate
const isContractorRoute = window.location.pathname.startsWith('/contractor');

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {isContractorRoute ? <ContractorPortal /> : <App />}
  </React.StrictMode>,
)
